import React from 'react';
import { ArrowRight } from '@procore/core-icons';
import { Box } from '@procore/core-react';

export const ArrowNext = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    style={{ height: '100%' }}
  >
    <ArrowRight
      data-testid="arrow-right"
      size="md"
      style={{ color: 'black' }}
    />
  </Box>
);
